import { Group } from 'business';
import { useQuery } from 'bridge';

export default function useClubGroups(clubId: string, isClubAdmin?: boolean, now?: Date) : Group[] {

    const clubGroups = useQuery({ clubId: clubId, isClubAdmin: isClubAdmin, queryType: 'clubGroups', date: now});
    return clubGroups;
}

